<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="chap1"><a id="start">Feb. 12</a></p><a id="start">
<p class="ind" style="margin-top:20px;">Saturday is Valentine’s Day.</p>
<p class="ind">So we will be allowed to celebrate it at school TOMORROW, Friday.</p>
<p class="ind">Unless you don’t have a Valentine. Like me.</p>
<p class="ind">Then you don’t celebrate. You walk around feeling sorry for yourself. You might as well stay home.</p>
<p class="ind">But look on the bright side, McCrae.</p>
<p class="ind">Tomorrow also happens to be Friday the 13th.</p>
<p class="ind">So maybe having a Valentine is unlucky. And the best thing to do is go to school and don’t worry.</p>
<p class="ind">You will not worry.</p>
<p class="ind">You will not worry.</p>
<p class="ind">You will not worry.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4chap1.vue?14f69e3b